<template>
    <svg :width="size" :height="size" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 3.5V2" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 3.5C11.0608 3.5 7.52791 7.29323 6.97182 12.2037M12 3.5C12.9392 3.5 16.4721 7.29322 17.0282 12.2037M12 3.5C16.9367 3.5 21.0545 6.93552 22 11.5C20.6123 12.7 18.1073 12.4691 17.0282 12.2037M12 3.5C7.06333 3.5 2.94545 6.93552 2 11.5C3.38792 12.7 5.89285 12.4691 6.97182 12.2037M6.97182 12.2037C8.4559 13.0288 10.1718 13.5 12 13.5C13.8282 13.5 15.5441 13.0288 17.0282 12.2037" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 13.5V20.5C12 21.3284 11.3284 22 10.5 22C9.67157 22 9 21.3284 9 20.5V20" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.5 15.875C16.6716 15.875 16 16.4626 16 17.1875C16 17.9124 16.6716 18.5 17.5 18.5C18.3284 18.5 19 19.0876 19 19.8125C19 20.5374 18.3284 21.125 17.5 21.125M17.5 15.875C18.1531 15.875 18.7087 16.2402 18.9146 16.75M17.5 15.875V15M17.5 21.125C16.8469 21.125 16.2913 20.7598 16.0854 20.25M17.5 21.125V22" :stroke="color" stroke-width="1.5" stroke-linecap="round"/>
</svg>
</template>

<script>
export default {
  name: 'IconForesight',
  props: {
    size: Number,
    color: String
  }
}
</script>